export const LOADER_TIMEOUT = 200;
export const LOADER_HIDE_TIMEOUT = 500;
